var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSfRevalida23(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 128,
    viewBox: "0 0 285 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-7 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.096,
    y1: 0.031,
    x2: 0.921,
    y2: 1.008,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.603,
    y1: 0.9,
    x2: 0.331,
    y2: -0.229,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3389",
    "data-name": "Caminho 3389",
    className: "cls-1",
    d: "M5.921,17.895a1.006,1.006,0,0,0-1.091.969,1.054,1.054,0,0,0,1.062,1.175c.582.065,2.946-.046,3.536-.067s1.1-.208,1.133-.887c.038-.729-.432-1.084-1.1-1.117q-1.511-.074-3.026-.076l-.512,0m136.047-.012a1.006,1.006,0,0,0-1.09.969,1.054,1.054,0,0,0,1.061,1.175,16,16,0,0,0,1.766.014c0-.025,0-.051,0-.076.59,0,1.181.016,1.77,0s1.1-.208,1.133-.886c.038-.729-.432-1.084-1.1-1.117q-1.508-.074-3.02-.076l-.518,0M6,4.322a1.051,1.051,0,0,0-1.1.994A1.079,1.079,0,0,0,5.949,6.533,22.708,22.708,0,0,0,11.13,6.5a1.043,1.043,0,0,0,.947-1.14,1.022,1.022,0,0,0-1.053-1.027c-.809-.047-1.622-.012-2.433-.012V4.311c-.518,0-1.036-.012-1.554-.012-.348,0-.7.005-1.042.024m136.047-.011a1.051,1.051,0,0,0-1.1.994A1.08,1.08,0,0,0,142,6.522a22.729,22.729,0,0,0,5.18-.035,1.043,1.043,0,0,0,.947-1.14,1.022,1.022,0,0,0-1.054-1.027c-.808-.047-1.622-.012-2.433-.012V4.3c-.518,0-1.037-.012-1.555-.012-.347,0-.694.005-1.041.024M21.543.012q-3.8,0-7.611.006h-.168c-.829,0-1.772-.008-1.751,1.162.021,1.214,1.1,1.146,1.959,1.163.748.015,1.5.011,2.246.008.822,0,1.645-.008,2.467.012.125,0,.26,0,.4,0,.77-.016,1.661-.032,1.631.979-.029.954-.856.926-1.6.9-.176-.007-.346-.013-.5-.007-.828.034-1.658.031-2.488.029-.47,0-.941,0-1.411,0-.726.008-1.321.264-1.344,1.086s.551,1.11,1.264,1.205c.214.028.434.021.648.051.587.084,1.325.1,1.294.9-.028.731-.691.909-1.317.923-1.3.029-2.6.024-3.9.026-3.3,0-6.609,0-9.913.014-.677,0-1.375.125-1.44.976-.068.892.556,1.229,1.331,1.311a11.248,11.248,0,0,0,1.224.041H2.8q6.582.006,13.163.007a14.033,14.033,0,0,1,1.46.048c.579.061,1.118.3,1.07.975-.042.586-.542.735-1.08.749-.974.025-1.947.1-2.921.1-1.176.009-2.351.008-3.527.006-.937,0-1.874,0-2.811,0-.768,0-1.455.191-1.428,1.148.025.906.675,1.151,1.451,1.183.379.016.758.01,1.137.01l9.186,0a8.491,8.491,0,0,0,.683,2.642,10.47,10.47,0,0,0,2.951,3.784c.279.235.54.467.786.695a15.215,15.215,0,0,1,1.33,1.382,5.058,5.058,0,0,1,1.43,3.064,2.108,2.108,0,0,1-.058.485l-.92,4.294c-.287,1.361-.958,1.968-2.179,1.968a1.346,1.346,0,0,1-1.019-.287.936.936,0,0,1-.189-.673,3.5,3.5,0,0,1,.08-.709,50.659,50.659,0,0,0,1.2-5.828,2.37,2.37,0,0,0-.928-.085h-5.9s-2.342.194-3.373.194c-.433,0-.867-.005-1.3.01-.678.024-1.372.1-1.4.987s.627,1.031,1.326,1.06c.487.021.978-.009,1.461.044.632.069,1.481.058,1.463.922s-.858.839-1.5.848c-1.841.023-3.683,0-5.525.022-.768.008-1.687.021-1.663,1.076.023,1.03.917,1.04,1.7,1.038q3.54-.01,7.08-.014a.428.428,0,0,1,.386.242q-.089.541-.13,1.047l-.123.579h.091c0,.084,0,.167,0,.248s0,.19,0,.286a6.367,6.367,0,0,0,.746,2.929,4.784,4.784,0,0,0,1.285,1.478,7.17,7.17,0,0,0,3.62,1.3,13.528,13.528,0,0,0,1.463.081c5.532,0,8.944-2.846,10.14-8.458l1.013-4.741a10.352,10.352,0,0,0,.225-2.094,8.468,8.468,0,0,0-.994-4.012,9.69,9.69,0,0,0-1.045-1.574A11.873,11.873,0,0,0,29.535,18q-.23-.212-.475-.419c-.389-.328-.744-.65-1.071-.964a8.882,8.882,0,0,1-2.324-3.153,2.713,2.713,0,0,1-.17-.891,2.037,2.037,0,0,1,.041-.422l.726-3.4a2.759,2.759,0,0,1,.7-1.455,1.994,1.994,0,0,1,1.464-.513h.031c.63.006,1.2.086,1.2.979a3.428,3.428,0,0,1-.08.69l-1.254,5.913h6.879l1.19-5.609a12.735,12.735,0,0,0,.322-2.694,6.932,6.932,0,0,0-.5-2.7C35.431,1.525,33.58.01,29.588.01c0,0-8.044,0-8.045,0m25.73,5.7h2.045q2.045,0,2.045,1.8a4.229,4.229,0,0,1-.123.94l-1.268,6.032a3.247,3.247,0,0,1-2.127,2.556,6.036,6.036,0,0,1-1.7.163H44.82ZM42.693.01,34.167,40.127h5.786l3.66-17.2h.94A14.181,14.181,0,0,0,48.5,22.5a9.969,9.969,0,0,0,7.259-8.015l1.268-6.032a13.667,13.667,0,0,0,.348-2.883q0-5.541-6.257-5.562ZM67.7,5.715h2.045q2.044,0,2.045,1.8a4.259,4.259,0,0,1-.123.94L70.4,14.486a3.248,3.248,0,0,1-2.126,2.556,6.041,6.041,0,0,1-1.7.163H65.246ZM63.12.01,54.594,40.127H60.38L64.1,22.583l.756-.1L66.33,40.127h6.339L70.133,21.459a8.825,8.825,0,0,0,6.052-6.972l1.268-6.032A13.665,13.665,0,0,0,77.8,5.572Q77.8.031,71.544.01Zm21.449,0L76.042,40.127h5.787L90.355.01Zm22.471,0-4.948,23.268L101.56.01H95.773L87.247,40.127h5.562l4.784-22.533.491,22.533h5.786L112.4.01Zm9.038,0-1.206,5.7h5.418l-7.32,34.412h5.787l7.32-34.412h5.419L132.7.01ZM157.589,0V0q-3.805,0-7.61.005h-.168c-.829,0-1.772-.008-1.751,1.162.021,1.214,1.1,1.146,1.959,1.163.747.015,1.494.011,2.242.008.823,0,1.646-.008,2.469.012.124,0,.259,0,.4,0,.771-.016,1.662-.033,1.632.979-.029.954-.856.925-1.6.9-.175-.006-.346-.013-.5-.007-.826.033-1.654.031-2.482.029-.473,0-.945,0-1.418,0-.726.008-1.321.264-1.344,1.086s.552,1.11,1.264,1.2c.215.029.434.021.648.051.586.084,1.324.1,1.294.9-.028.732-.691.909-1.317.923-1.3.029-2.6.024-3.9.026-3.3.005-6.608,0-9.911.014-.677,0-1.375.126-1.44.976-.068.892.556,1.229,1.331,1.311a11.291,11.291,0,0,0,1.223.041h.237q6.581.006,13.162.007a14.031,14.031,0,0,1,1.46.048c.579.061,1.118.3,1.07.974-.042.586-.542.735-1.079.749-.974.025-1.947.1-2.921.1-1.18.009-2.36.008-3.54.007q-1.4,0-2.8,0c-.768,0-1.455.191-1.428,1.148.026.906.676,1.151,1.451,1.183.379.016.758.01,1.137.01l8.515,0a.429.429,0,0,1,.419.518l-.427,2.013a.429.429,0,0,1-.42.34h-3.093c-.433,0-.867-.005-1.3.01-.678.025-1.372.1-1.4.986s.627,1.031,1.326,1.06c.487.021.978-.009,1.461.044.632.069,1.481.058,1.463.922s-.858.839-1.5.847c-1.841.023-3.683,0-5.524.022-.768.009-1.687.021-1.663,1.075.023,1.03.917,1.04,1.7,1.037q3.539-.009,7.079-.013a.429.429,0,0,1,.42.517L149.189,39.6a.429.429,0,0,0,.419.518H155.7a.429.429,0,0,0,.419-.34l3.37-15.923a.429.429,0,0,1,.42-.34h6.966a.428.428,0,0,0,.419-.339l1.273-5.942.024-.11a.429.429,0,0,0-.419-.519h-6.6a.429.429,0,0,1-.42-.518l.228-1.078,1.3-6.174.517-2.528a.428.428,0,0,1,.42-.343l4.5,0c4.431,0,5.333-5.941,5.333-5.941l0-.02Zm19.12,0-8.526,40.117h5.787L182.495,0ZM199.18,0l-4.948,23.268L193.7,0h-5.787l-8.526,40.117h5.562l4.784-22.533.491,22.533h5.787L204.537,0Zm16.787,9.2-1.329,16.684h-4.416ZM213.983,0l-9.61,25.947-4.887,14.17h5.827l2.945-8.506h5.909l-.675,8.506h5.848l1.145-14.231L221.916,0Zm17.359,0-8.526,40.117h15.008l1.206-5.7h-9.222L237.129,0Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2729",
    "data-name": "Ret\\xE2ngulo 2729",
    className: "cls-2",
    width: 239.03,
    height: 85.146
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3396",
    "data-name": "Caminho 3396",
    className: "cls-3",
    d: "M187.206,171.521l-10.284,29.846,2.408-29.846h-5.645l-1.086,13.7-1.382,25.029h7.658l9.238-24.99,4.737-13.738Z",
    transform: "translate(-171.218 -171.521)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1272",
    "data-name": "Grupo 1272",
    transform: "translate(35.35 15.696)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1664",
    "data-name": "Ret\\xE2ngulo 1664",
    className: "cls-2",
    width: 285,
    height: 128,
    transform: "translate(-35.35 -15.696)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5619",
    "data-name": "Grupo 5619",
    transform: "translate(-12.423 5.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5537",
    "data-name": "Grupo 5537",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5536",
    "data-name": "Grupo 5536",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2728",
    "data-name": "Ret\\xE2ngulo 2728",
    className: "cls-1",
    width: 227.124,
    height: 154.298,
    transform: "translate(-17.439 10.032) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5539",
    "data-name": "Grupo 5539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5538",
    "data-name": "Grupo 5538",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3390",
    "data-name": "Caminho 3390",
    className: "cls-6",
    d: "M602.716,171.521H608.3l-8.231,38.728h-5.586Z",
    transform: "translate(-433.602 -125.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3391",
    "data-name": "Caminho 3391",
    className: "cls-6",
    d: "M642.687,171.521h5.586l.513,22.463,4.777-22.463h5.172L650.5,210.249h-5.586l-.474-21.752-4.619,21.752h-5.369Z",
    transform: "translate(-462.755 -125.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3392",
    "data-name": "Caminho 3392",
    className: "cls-6",
    d: "M720.95,171.521h14.489l-1.165,5.507h-8.9L723,188.121h7.659l-1.164,5.527h-7.659l-2.369,11.094h8.9l-1.165,5.507H712.719Z",
    transform: "translate(-519.838 -125.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3393",
    "data-name": "Caminho 3393",
    className: "cls-6",
    d: "M789.8,171.52h8.133q6.04.02,6.04,5.369a13.2,13.2,0,0,1-.336,2.783l-1.224,5.823a9.624,9.624,0,0,1-7.008,7.738,13.7,13.7,0,0,1-3.81.414h-.908l-3.533,16.6h-5.586Zm4.422,5.507-2.368,11.093h1.283a5.831,5.831,0,0,0,1.638-.158,3.135,3.135,0,0,0,2.053-2.467l1.224-5.823a4.087,4.087,0,0,0,.119-.908q0-1.737-1.974-1.737Z",
    transform: "translate(-570.059 -125.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3394",
    "data-name": "Caminho 3394",
    className: "cls-6",
    d: "M19.713,171.52h8.133q6.04.02,6.04,5.369a13.2,13.2,0,0,1-.336,2.783L32.327,185.5a8.521,8.521,0,0,1-5.843,6.731l2.448,18.022H22.812l-1.421-17.035-.73.1-3.592,16.936H11.482Zm4.421,5.507-2.369,11.093h1.283a5.831,5.831,0,0,0,1.638-.158A3.135,3.135,0,0,0,26.74,185.5l1.224-5.823a4.088,4.088,0,0,0,.119-.908q0-1.737-1.974-1.737Z",
    transform: "translate(-8.375 -125.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3395",
    "data-name": "Caminho 3395",
    className: "cls-6",
    d: "M95.862,171.521H110.35l-1.165,5.507h-8.9l-2.369,11.093h7.659l-1.165,5.527H96.75l-2.369,11.094h8.9l-1.165,5.507H87.631Z",
    transform: "translate(-63.915 -125.103)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5541",
    "data-name": "Grupo 5541",
    transform: "translate(46.336 46.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5540",
    "data-name": "Grupo 5540",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2730",
    "data-name": "Ret\\xE2ngulo 2730",
    className: "cls-3",
    width: 31.958,
    height: 43.344,
    transform: "matrix(0.957, -0.291, 0.291, 0.957, -10.772, 3.273)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5543",
    "data-name": "Grupo 5543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5542",
    "data-name": "Grupo 5542",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3397",
    "data-name": "Caminho 3397",
    className: "cls-6",
    d: "M244.006,196.51,242.9,210.248h-5.645l.651-8.212h-5.7l-2.842,8.212h-5.625l4.718-13.679,9.277-25.049h7.659Zm-5.645,0,1.283-16.107L234.1,196.51Z",
    transform: "translate(-163.186 -125.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3398",
    "data-name": "Caminho 3398",
    className: "cls-6",
    d: "M306.957,210.249l8.231-38.728h5.586l-7.067,33.221h8.9l-1.164,5.507Z",
    transform: "translate(-223.886 -125.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3399",
    "data-name": "Caminho 3399",
    className: "cls-6",
    d: "M381.489,171.521h5.587l-8.231,38.728h-5.586Z",
    transform: "translate(-272.244 -125.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3400",
    "data-name": "Caminho 3400",
    className: "cls-6",
    d: "M421.46,171.52h8.606q6.04.02,6.04,5.369a13.2,13.2,0,0,1-.336,2.783l-4.757,22.444q-1.737,8.113-9.534,8.133h-8.251Zm4.421,5.507-5.9,27.714h2.448a2.882,2.882,0,0,0,3-2.625l4.757-22.444a4.1,4.1,0,0,0,.119-.908q0-1.737-1.974-1.737Z",
    transform: "translate(-301.398 -125.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3401",
    "data-name": "Caminho 3401",
    className: "cls-6",
    d: "M503.741,196.51l-1.105,13.739H496.99l.651-8.212h-5.7l-2.842,8.212h-5.626l4.718-13.679,9.277-25.049h7.659Zm-5.645,0,1.283-16.107-5.547,16.107Z",
    transform: "translate(-352.63 -125.102)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSfRevalida23);
export default __webpack_public_path__ + "static/media/logo-sf-revalida-23.afa6f980d72553950ded3a7e1ac741ca.svg";
export { ForwardRef as ReactComponent };